import { useEffect } from "react";
import { migrateLegacyDownloadAppCookie } from "../../../utils/promoMaterial/promoPopupHistory";
import { useAppSelector } from "../useReduxHooks";

/**
 * Moves the pre-migration download-app cookie into the pop-up ledger, once.
 *
 * Without this the ledger starts empty on a restaurant that has just flipped
 * `useLoyaltyPopups`, so the first guest is shown the download-app pop-up again
 * however recently they saw it — and the legacy `.prepit.app` cookie is never
 * cleaned up.
 *
 * Gated on the flag on purpose, and this is the part that matters: the migration
 * *removes* that cookie, and the cookie is domain-wide. Running it for a
 * restaurant still on the legacy path would delete the memory that path reads
 * and re-show its pop-up — the same bug, mirrored. Only a restaurant whose
 * pop-ups the loyalty service already owns may consume it.
 */
export const useLegacyDownloadAppCookieMigration = (): void => {
  const useLoyaltyPopups = useAppSelector(
    (state) => state.config.restaurantConfig?.useLoyaltyPopups
  );

  useEffect(() => {
    if (useLoyaltyPopups !== true) {
      return;
    }
    // Idempotent: it returns early once the cookie is gone, so re-running as the
    // config arrives (or across route changes) costs one cookie read.
    migrateLegacyDownloadAppCookie();
  }, [useLoyaltyPopups]);
};
